import { supabase } from '@/integrations/supabase/client';

export type SendNotificationKind =
  | 'challenge'
  | 'team_match_created'
  | 'team_match_invitation'
  | 'match_updated'
  | 'match_participant_left';

export interface SendNotificationInput {
  kind: SendNotificationKind;
  target_profile_ids: string[];
  match_id?: string;
  team_id?: string;
  inviter_team_id?: string;
  invitee_team_id?: string;
  metadata?: Record<string, unknown>;
}

/**
 * Send cross-user notifications via the `send-notification` Edge Function.
 * The function uses service_role to bypass RLS and validates the caller's
 * authorization per `kind` before fanning out.
 *
 * Errors are logged but NOT thrown — notifications are a side-effect and
 * must never break the main mutation (match edit, team invite, etc.).
 */
export async function sendNotification(input: SendNotificationInput): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke('send-notification', { body: input });
    if (error) {
      console.warn('[sendNotification] failed', input.kind, error);
    }
  } catch (err) {
    console.warn('[sendNotification] threw', input.kind, err);
  }
}
